var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsHotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 0C11.875 0 12.8 3.3125 12.8 6C12.8 8.575 11.1125 10.6688 8.53125 10.6688C5.95 10.6688 4 8.58125 4 6L4.03125 5.55C1.51875 8.55625 0 12.4313 0 16.6625C0 22.1875 4.475 26.6625 10 26.6625C15.525 26.6625 20 22.1875 20 16.6625C20 9.91875 16.7563 3.90625 11.875 0ZM9.6375 22.9125C7.4125 22.9125 4.60625 20.1563 4.60625 17.9875C4.60625 15.9563 5.9125 14.5313 8.125 14.0875C10.3375 13.6438 13.625 13.5813 14.8938 11.8688C15.3813 13.4813 15.6375 15.1813 15.6375 16.9125C15.6375 20.2188 12.95 22.9125 9.6375 22.9125Z",
    fill: "#1A1A1A",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsHotIcon);
export default __webpack_public_path__ + "static/media/whats_hot_icon.a7a26d74.svg";
export { ForwardRef as ReactComponent };